@use '../../design-tokens/typography/typography' as *;
@use '../custom-scroll/custom-scroll' as *;

@layer design-system {
  .actionTableCell {
    > div {
      visibility: hidden;
    }
  }

  .styledTableRow:hover {
    .actionTableCell {
      > div {
        visibility: visible;
      }
    }
  }

  .styledTableRowClickable:hover {
    cursor: pointer;
  }

  .tableHeaderTitle {
    background-color: var(--background-default);
    border-bottom: 1px solid var(--border-soft);
    padding: 12px;
    text-align: center;
    white-space: nowrap;
    @include typography-v2-body-xs;
    vertical-align: middle;
    color: var(--text-soft);
  }

  .stickyTableHeader {
    position: sticky;
    left: 0;
    z-index: calc(var(--z-index-smarttable-sticky-header-cell) + 1);
  }

  .stickyTableHeaderBorder {
    border-right: 1px solid var(--border-default);
  }

  .table {
    border-spacing: 0;
    width: 100%;

    tr {
      background-color: var(--background-default);
      td {
        background-color: var(--background-default);
      }
    }
  }

  .tableWithBodyRowHover {
    tbody tr:hover {
      background-color: var(--surface-hover);
      td {
        background-color: var(--surface-hover);
      }
    }
  }

  .tableHeaderSticky {
    th {
      position: sticky;
      top: 0;
      z-index: var(--z-index-smarttable-sticky-header-cell);
    }

    [data-add-column-table-header] {
      z-index: calc(var(--z-index-smarttable-sticky-header-cell) + 2);
    }

    .stickyTableHeader {
      z-index: calc(var(--z-index-smarttable-sticky-header-cell) + 1);
    }
  }

  .smartTableScrollRoot {
    @include custom-scroll-minimal;
    height: 100%;
    max-height: fit-content;
    width: 100%;
    overflow: auto;
  }

  .smartTableScrollRootSticky {
    &::-webkit-scrollbar-track {
      margin-left: var(--first-column-width, 0);
    }
  }
}
